import { render, staticRenderFns } from "./ScopeEnableDisablePopUp.vue?vue&type=template&id=2dd1e201"
import script from "./ScopeEnableDisablePopUp.vue?vue&type=script&lang=js"
export * from "./ScopeEnableDisablePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports